import { useSubmitForm } from "../../../hooks/useSubmitForm";
import { adminLoyaltyService } from "../../api_client";
import type {
    UpdateLoyaltyConfigDto,
    LoyaltyConfigDto,
} from "../../../api";
import { showErrorToast, showSuccessToast } from "../../../utils/toasts";
import { useSWRConfig } from "swr";

export function useUpdateLoyaltyConfig(
    buildDto: () => UpdateLoyaltyConfigDto
) {
    const { mutate } = useSWRConfig();

    return useSubmitForm<UpdateLoyaltyConfigDto, LoyaltyConfigDto>({
        submitMethod: async () => {
            const dto = buildDto();
            return await adminLoyaltyService.updateConfig({
                pointsPer100: Number(dto.pointsPer100),
                validityDays: Number(dto.validityDays),
                redemptionValuePer100Points: Number(dto.redemptionValuePer100Points),
            });
        },
        runAfterError: (error) => {
            showErrorToast(error.message);
        },
        runAfterSuccess: async () => {
            showSuccessToast("Loyalty configuration updated successfully!");
            // Revalidate the loyalty config cache
            await mutate("loyalty-config");
        },
    });
}

